<template>
	<article
		v-editable="blok"
		class="max-sm:py-2 p-4 pe-9 flex items-start md:items-center rounded-full w-full max-w-full md:max-w-[calc(50%-1.25rem)] lg:max-w-[30.75rem]"
	>
		<div class="shrink-0 grow-0 rounded-full overflow-hidden w-[6.25rem] h-[6.25rem] lg:w-40 lg:h-40 mr-4">
			<NuxtPicture
				v-if="blok.image?.filename"
				provider="storyblok"
				width="160"
				height="160"
				:modifiers="storyblokFocusModifiers(blok.image.focus)"
				:src="blok.image.filename"
				:srcset="`${blok.image.filename}/m/100x100 100w, ${blok.image.filename}/m/160x160 160w`"
				:alt="blok.image.alt || ''"
				sizes="lg:100px inf:160px"
				:img-attrs="{class:'w-full h-full object-cover'}"
				loading="lazy"
			/>
		</div>
		<div class="block grow">
			<h3 class="typo-h4 mb-2">
				{{ blok.title }}
			</h3>
			<RichText class="font-primary typo-body-s" :data="blok.text" />
		</div>
	</article>
</template>

<script setup lang="ts">
	import type {BenefitsPresentationItemStoryblok} from '@/storyblok/types';

	interface Props {
		blok: BenefitsPresentationItemStoryblok
	}

	defineProps<Props>();
</script>
